// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

export default interface IDocCommandAlias {
  alias: string;
}
